import { render, staticRenderFns } from "./orderDetailInfo.vue?vue&type=template&id=2392d273&scoped=true"
import script from "./orderDetailInfo.vue?vue&type=script&lang=js"
export * from "./orderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./orderDetailInfo.vue?vue&type=style&index=0&id=2392d273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392d273",
  null
  
)

export default component.exports